/**
 * Created by ianva on 16/7/21.
 */

var _ = require('underscore');

var moment = require("moment");

var {CMEvent} = require("../lib/CMEvent");

var StoreMixin = require("./StoreMixin");

var Dispatcher = require("../Dispatcher");

var {ActionConstants, EventConstants} = require("../Constants");

var UIStore = _.extend({}, new CMEvent(), StoreMixin, {

});

UIStore.dispatchToken = Dispatcher.register(function (payload) {

    switch (payload.type) {

        case ActionConstants.LOADING_LAYER_SHOW:
            UIStore.emit_event(EventConstants.LOADING_LAYER);
            break;

        case ActionConstants.ADD_NOTIFY:
            UIStore.emit_event(EventConstants.ADD_NOTIFY,[payload.message]);
            break;

    }


});

module.exports = UIStore;



/** WEBPACK FOOTER **
 ** ./script/store/UIStore.js
 **/